import axios from "axios"

export default class ServiceREST
{
    public rest(method, url, data = null)
    {
        let response;

        switch (method) {
            case 'get':
                response = this.get(url);
                break;

            case 'post':
                response = this.post(url, data);
                break;

            case 'put':
                response = this.put(url, data);
                break;

            case 'delete':
                response = this.delete(url);
                break;
        }

        return response;
    }

    private async get(url)
    {
        let responseData;

        responseData = await this.apiJSON().get(url).then(
            response => { return response.data }
        );

        return responseData;
    }

    public async post(url, data)
    {
        let responseData;
        await this.apiJSON().post(url, data).then(
            response => { responseData = response.data }
        );

        return responseData;
    }

    private async put(url, data)
    {
        let responseData;
        await this.apiJSON().put(url, data).then(
            response => { responseData = response.data }
        );
        return responseData;
    }

    private async delete(url)
    {
        let responseData;
        await this.apiJSON().delete(url).then(
            response => { responseData = response.data }
        );
        return responseData;
    }

    public apiJSON()
    {
        return axios.create({
            baseURL: '',
            withCredentials: false,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
    }
}import axios from "axios"

export default class ServiceREST
{
    public rest(method, url, data = null)
    {
        let response;

        switch (method) {
            case 'get':
                response = this.get(url);
                break;

            case 'post':
                response = this.post(url, data);
                break;

            case 'put':
                response = this.put(url, data);
                break;

            case 'delete':
                response = this.delete(url);
                break;
        }

        return response;
    }

    private async get(url)
    {
        let responseData;

        responseData = await this.apiJSON().get(url).then(
            response => { return response.data }
        );

        return responseData;
    }

    public async post(url, data)
    {
        let responseData;
        await this.apiJSON().post(url, data).then(
            response => { responseData = response.data }
        );

        return responseData;
    }

    private async put(url, data)
    {
        let responseData;
        await this.apiJSON().put(url, data).then(
            response => { responseData = response.data }
        );
        return responseData;
    }

    private async delete(url)
    {
        let responseData;
        await this.apiJSON().delete(url).then(
            response => { responseData = response.data }
        );
        return responseData;
    }

    public apiJSON()
    {
        return axios.create({
            baseURL: '',
            withCredentials: false,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
    }
}